import { render } from "./vfileclassifyadd.vue?vue&type=template&id=8fe2a80c&scoped=true"
import script from "./vfileclassifyadd.vue?vue&type=script&lang=js"
export * from "./vfileclassifyadd.vue?vue&type=script&lang=js"

import "./vfileclassifyadd.vue?vue&type=style&index=0&id=8fe2a80c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fe2a80c"]])

export default __exports__